// extracted by mini-css-extract-plugin
module.exports = {"Title":"Title--2w8zu","H6":"H6--m3tBV","Light":"Light--1I1Ag","Black":"Black--3FHgt"};